import { useMemo, useState } from 'react';

export const useChoseOptionsWithSearch = ({
  data,
  initialValues
}: {
  data: { label: string; value: string }[];
  initialValues: string | string[];
}) => {
  const [value, setValue] = useState<string | string[]>(initialValues || '');
  const [search, setSearch] = useState<string>('');

  const filteredCity = useMemo(
    () =>
      data.filter((item) =>
        item.value.toLowerCase().includes(search.toLowerCase())
      ),
    [search]
  );

  return {
    state: {
      value,
      search,
      filteredCity
    },
    functions: {
      setValue,
      setSearch
    }
  };
};
